module.exports = __webpack_public_path__ + "static/media/SoloStan_Bookcover.5e47be0d.jpg";